import {useTranslation} from 'react-i18next'
import {useAuth} from '../../../app/modules/auth'

const campusFollowText = {
  1: 'LABEL.FOLLOW_SWISS_UMEF',
  8: 'LABEL.FOLLOW_COTE_UMEF',
  17: 'LABEL.FOLLOW_DAKAR_UMEF',
}

const SOCIAL_PLATFORMS = {
  facebook: {
    name: 'Facebook',
    bgColor: '#4267B2',
    icon: (
      <svg xmlns='http://www.w3.org/2000/svg' width='22' height='22' fill='white'>
        <path d='M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z' />
      </svg>
    ),
  },
  instagram: {
    name: 'Instagram',
    bgColor: '#8a3ab9',
    icon: (
      <svg xmlns='http://www.w3.org/2000/svg' width='22' height='22' fill='white'>
        <rect x='2' y='2' width='20' height='20' rx='5' />
        <circle cx='12' cy='12' r='4' />
        <circle cx='17.5' cy='6.5' r='1' />
      </svg>
    ),
  },
  linkedin: {
    name: 'LinkedIn',
    bgColor: '#0e76a8',
    icon: (
      <svg xmlns='http://www.w3.org/2000/svg' width='22' height='22' fill='white'>
        <rect x='2' y='9' width='4' height='12' />
        <circle cx='4' cy='4' r='2' />
        <path d='M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-4 0v7h-4v-7a6 6 0 0 1 6-6z' />
      </svg>
    ),
  },
  x: {
    name: 'X',
    bgColor: '#000',
    icon: (
      <svg xmlns='http://www.w3.org/2000/svg' width='22' height='22' fill='white'>
        <path d='M4 4l16 16M20 4L4 20' stroke='white' strokeWidth='2' />
      </svg>
    ),
  },
  youtube: {
    name: 'YouTube',
    bgColor: '#c4302b',
    icon: (
      <svg xmlns='http://www.w3.org/2000/svg' width='22' height='22' fill='white'>
        <path d='M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2z' />
        <polygon points='9.75 15.02 15.5 11.75 9.75 8.48' />
      </svg>
    ),
  },
}

const campusMedia = {
  1: {
    facebook: 'https://www.facebook.com/SwissUmefGeneva/',
    instagram: 'https://www.instagram.com/SwissUmefGeneva/',
    linkedin: 'https://www.linkedin.com/company/swissumefgeneva/',
    x: 'https://twitter.com/SwissUmefGeneva',
    youtube: 'https://www.youtube.com/@SwissUmefGeneva',
  },
  8: {
    facebook: 'https://www.facebook.com/suissumefci/',
    instagram: 'https://www.instagram.com/swiss_umef_campus_abidjan?igsh=MXR2dXVreHBzcTNnaQ==',
    linkedin: 'https://www.linkedin.com/company/swissumefgeneva/',
    x: 'https://twitter.com/SwissUmefGeneva',
    youtube: 'https://www.youtube.com/channel/UCYnjSwx5SykLmKyqCg4Nkqg',
  },
  17: {
    facebook: 'https://www.facebook.com/people/SWISS-UMEF-University-Campus-Dakar/61577564364093/',
    instagram: 'https://www.instagram.com/swissumefdakar/',
    linkedin: 'https://www.linkedin.com/company/swiss-umef-university-campus-dakar/',
    youtube: 'https://www.youtube.com/@SWISSUMEFUniversity-CampusDaka',
  },
}

const getCampusSocialMedia = (campusId) => {
  const links = campusMedia[campusId] || campusMedia[1]

  return Object.entries(links).map(([key, link]) => ({
    ...SOCIAL_PLATFORMS[key],
    link,
  }))
}

const SocialMedia = () => {
  const {t} = useTranslation()
  const {currentUser} = useAuth()

  const campusId = currentUser?.campus_id || 1
  const followKey = campusFollowText[campusId] || 'LABEL.FOLLOW_UMEF'
  const mediaList = getCampusSocialMedia(campusId)

  return (
    <div className='card p-none'>
      <div className='card-body p-3'>
        <div className='d-flex align-items-center justify-content-between flex-wrap gap-3'>
          <div className='text-start'>
            <h2 className='fw-bold text-primary m-0'>{t(followKey)}</h2>
          </div>

          <div className='d-flex flex-wrap gap-3'>
            {mediaList.map((item) => (
              <a
                key={item.name}
                href={item.link}
                target='_blank'
                rel='noopener noreferrer'
                aria-label={item.name}
                className='d-flex align-items-center justify-content-center rounded-circle shadow-sm social-btn'
                style={{
                  backgroundColor: item.bgColor,
                  width: 55,
                  height: 55,
                  transition: 'all 0.3s ease',
                }}
              >
                {item.icon}
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default SocialMedia
